import { api } from './client'

/** Окно «Отказов нейросетей» (services/refusals на сервере): предупреждение за нарушение или «токены списаны».
 *  Решение по деньгам принимает сервер при отказе — в любом разделе; сайт забирает то, что человек ещё не видел. */
export interface RefusalNotice {
	id?: string
	/** Все непоказанные уведомления этой группы и решения — отказы подряд показываются одним окном. */
	ids?: string[]
	count?: number
	request_id?: string | null
	group: string
	title: string | null
	action: 'warn' | 'charge'
	text: string | null
	credits: number
	created_at?: string | null
}

export function getRefusalNotices() {
	return api.request<{ notices: RefusalNotice[] }>('/api/v1/refusals/notices')
}

export function markRefusalNoticesSeen(ids: string[]) {
	return api.request<{ ok: boolean }>('/api/v1/refusals/notices/seen', { method: 'POST', body: { ids } })
}

/** «Проверь окна отказов сейчас» — после провала генерации в любом разделе (иначе окно появится при следующей
 *  плановой проверке, до 30 секунд). */
export const REFUSAL_CHECK_EVENT = 'refusal-check'

export function requestRefusalCheck() {
	window.dispatchEvent(new CustomEvent(REFUSAL_CHECK_EVENT))
}
